import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './BrandSafetyThree.style';

const BrandSafetyThree = () => {
  const { t } = useTranslation('brandSafety');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('brandSafetyThree.title.spanBefore')}
          <span>2</span> {t('brandSafetyThree.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <p>
          {t('brandSafetyThree.subtitle.spanBefore')}
          <span>2</span> {t('brandSafetyThree.subtitle.spanAfter')}
        </p>
        <TextBox1>
          <div>
            <p>{t('brandSafetyThree.paragraphOne')}</p>
          </div>
        </TextBox1>
        <TextBox2>
          <div className="grid-content">
            <h2>
              <span>1.</span>
              {t('brandSafetyThree.paragraphTwo.title')}
            </h2>
            <p>{t('brandSafetyThree.paragraphTwo.paragraph')}</p>
          </div>
          <div className="grid-content">
            <h2>
              <span>2.</span>
              {t('brandSafetyThree.paragraphThree.title')}
            </h2>
            <p>{t('brandSafetyThree.paragraphThree.paragraph')}</p>
            <ul>
              <li>{t('brandSafetyThree.paragraphThree.ul.liOne')}</li>
              <li>{t('brandSafetyThree.paragraphThree.ul.liTwo')}</li>
              <li>{t('brandSafetyThree.paragraphThree.ul.liThree')}</li>
              <li>{t('brandSafetyThree.paragraphThree.ul.liFour')}</li>
            </ul>
          </div>
          <div className="grid-content">
            <h2>
              <span>3.</span>
              {t('brandSafetyThree.paragraphFour.title')}
            </h2>
            <p>{t('brandSafetyThree.paragraphFour.paragraph')}</p>
          </div>
          <div className="grid-content">
            <h2>
              <span>4.</span>
              {t('brandSafetyThree.paragraphFive.title')}
            </h2>
            <p>{t('brandSafetyThree.paragraphFive.paragraph')}</p>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSafetyThree;
